<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card :loading="isLoading">
      <v-card-title
        class="justify-center"
        style="word-break: normal; font-size: 24px"
      >
        {{ title }}
      </v-card-title>
      <v-card-text class="text-center mt-1" style="font-size: 24px">
        {{ description.toUpperCase() }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="isLoading && loadingAttend"
          color="green darken-1"
          text
          @click="attendCustomer"
        >
          Atender Cliente
        </v-btn>
        <v-btn
          :loading="isLoading && loadingcancel"
          color="green darken-1"
          text
          @click="cancelAttention"
        >
          Cancelar atención
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AttendCustomerModal',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
  },
  data: () => ({
    show: false,
    payload: null,
    loadingAttend: false,
    loadingcancel: false,
  }),
  watch: {
    isLoading: function (newVal) {
      if (newVal === false) {
        this.loadingAttend = newVal;
        this.loadingcancel = newVal;
      }
    },
  },
  methods: {
    open(data) {
      this.payload = data;
      this.show = true;
    },
    close() {
      this.show = false;
    },
    attendCustomer() {
      // this.show = false;
      this.loadingAttend = true;
      this.$emit('onAttendCustomer', this.payload);
    },
    cancelAttention() {
      this.loadingcancel = true;
      this.$emit('onCancelAttention', this.payload);
    },
  },
  destroyed() {
    this.loadingAttend = false;
    this.loadingcancel = false;
  },
};
</script>

<style></style>
